import { z } from '../params'

// The console's helper-method route invokes a loader with `methodData = { payload }`, and a loader's
// payload is `{ criteria }` — the current values of the params it depends on. LOOSE, like every wrapper the
// runtime owns: the console may send fields a given milestone doesn't model yet, and dropping them silently
// would be worse than carrying them through.
export const LoaderPayloadSchema = z.looseObject({
  criteria: z.record(z.string(), z.unknown()).optional(),
})
